import { getCookie } from '../../helpers';

export async function getUserFromCookie() {
  const userCookie = getCookie('user');
  if (!userCookie) return;

  let userFromCookie;
  try {
    userFromCookie = JSON.parse(decodeURIComponent(userCookie));
  } catch (error) {
    return;
  }

  if (!userFromCookie) return;
  const user = { logged: true, data: userFromCookie };
  await this.setState({ user });
}

export function logout() {
  if (this.props.navigate) {
    this.props.navigate('/signout');
  }
}
